import React, { createContext, useContext, useState } from 'react';

interface ApiContextType {
  apiKey: string;
  apiBaseUrl: string;
  setApiKey: (key: string) => void;
  setApiBaseUrl: (url: string) => void;
  clearApiKey: () => void;
}

const ApiContext = createContext<ApiContextType | undefined>(undefined);

export const useApi = () => {
  const context = useContext(ApiContext);
  if (context === undefined) {
    throw new Error('useApi must be used within an ApiProvider');
  }
  return context;
};

interface ApiProviderProps {
  children: React.ReactNode;
}

export const ApiProvider: React.FC<ApiProviderProps> = ({ children }) => {
  const [apiKey, setApiKeyState] = useState(() => {
    return localStorage.getItem('ask-engine-api-key') || '';
  });
  
  const [apiBaseUrl, setApiBaseUrlState] = useState(() => {
    return localStorage.getItem('ask-engine-api-base-url') || 'https://lllm.awareai.aware.co.th';
  });

  const setApiKey = (key: string) => {
    setApiKeyState(key);
    if (key) {
      localStorage.setItem('ask-engine-api-key', key);
    } else {
      localStorage.removeItem('ask-engine-api-key');
    }
  };

  const setApiBaseUrl = (url: string) => {
    setApiBaseUrlState(url);
    localStorage.setItem('ask-engine-api-base-url', url);
  };

  const clearApiKey = () => {
    setApiKeyState('');
    localStorage.removeItem('ask-engine-api-key');
  };

  return (
    <ApiContext.Provider value={{ 
      apiKey, 
      apiBaseUrl, 
      setApiKey, 
      setApiBaseUrl, 
      clearApiKey 
    }}>
      {children}
    </ApiContext.Provider>
  );
};